import { render, staticRenderFns } from "./ViewPurchaseOrder.vue?vue&type=template&id=d6e72a96&scoped=true&"
import script from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewPurchaseOrder.vue?vue&type=style&index=0&id=d6e72a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e72a96",
  null
  
)

export default component.exports